import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DividedPage } from '../../../components/DividedPage';
import { Heading } from '../../components/Heading';
import { useAppDispatch, useAppSelector } from '../../../reduxstore/hooks';
import { toggleShowLogin } from '../../../domains/UI/store/slice';

export const Login: React.FC = () => {
	const data = useAppSelector(state => state.accountReducer.profile);
	const dispatch = useAppDispatch();
	const handleClick = () => {
		dispatch(toggleShowLogin());
	};

	const authenticated = data.id !== null ? true : false;
	const navigate = useNavigate();

	useEffect(() => {
		if (authenticated) {
			navigate('../profile', { replace: true });
		}
	}, [authenticated, navigate]);

	return (
		<DividedPage className="checkout-login">
			<Heading className="pb-0">Who's picking this up?</Heading>

			<DividedPage>
				<>
					<h6 className="mb-1">
						Sign in with your B Happy Lounge account
					</h6>
					{/* <small className="d-block mb-1">
							<SignUp />
						</small> */}
					<div style={{ maxWidth: 300 }}>
						<div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
							<button
								className="btn text-white btn-primary w-50"
								onClick={handleClick}
							>
								Login
							</button>

							<button
								className="btn btn-link p-0"
								onClick={() => navigate('../profile')}
							>
								Continue as guest
							</button>
						</div>
					</div>
				</>
			</DividedPage>
		</DividedPage>
	);
};
